import { render, staticRenderFns } from "./QuizDispensingModalComponent.vue?vue&type=template&id=2ebb64a7&scoped=true"
import script from "./QuizDispensingModalComponent.vue?vue&type=script&lang=js"
export * from "./QuizDispensingModalComponent.vue?vue&type=script&lang=js"
import style0 from "./QuizDispensingModalComponent.vue?vue&type=style&index=0&id=2ebb64a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb64a7",
  null
  
)

export default component.exports